import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
  ReactiveFormsModule,
} from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { AuthService } from "../auth.service";
import { NgxSpinnerService } from "ngx-spinner";
import { MessageModule } from "primeng/message";
import { CommonModule } from "@angular/common";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
@Component({
  standalone: true,
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    InputTextModule,
    ButtonModule,
  ],
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  submitted = false;
  error: {};
  loginError: string;
  decodedUser: any;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit() {
    this.loginForm = this.fb.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });

    this.spinner.hide();
  }

  get username() {
    return this.loginForm.get("username");
  }
  get password() {
    return this.loginForm.get("password");
  }

  onSubmit() {
    this.submitted = true;

    if (this.loginForm.invalid) return;

    this.authService
      .login(this.username?.value, this.password?.value)
      .subscribe(
        (data) => {
          if (this.authService.isLoggedIn()) {
            this.decodedUser = this.authService.getDecodedToken();
            console.log("Decoded JWT payload:", this.decodedUser);

            const redirect = this.authService.redirectUrl || "/admin";
            this.router.navigateByUrl(redirect).then((success) => {
              if (!success) {
                this.loginError = "Failed to navigate after login.";
              }
            });
          } else {
            this.loginError = "Username or password is incorrect.";
          }
        },
        (error) => {
          this.error = error;
          this.loginForm.reset();

          if (error.error?.message) {
            this.loginError = error.error.message;
          } else if (error.status === 0) {
            this.loginError =
              "Cannot connect to server. Please try again later.";
          } else {
            this.loginError = "An unexpected error occurred.";
          }
        },
      );
  }
}
